import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import get from 'lodash.get'
import ActivityList from '../../../molecules/Activities/ActivityList'
import { evaluateObjectFilter } from '../../../../utils/objectFilter/evaluateObjectFilter'
import { usePipelineDataContextWithVariables } from '../provider/DDPDataProvider'

/**
 * A table component for displaying data from the Denali Data Pipeline.
 * @param pipeline
 * @param variableDefaults
 * @param seriesAccessor
 * @param valueAccessor
 * @param filter
 * @param rest
 * @returns {JSX.Element|null}
 * @constructor
 */
function DDPActivityList ({
  pipeline,
  variables,
  seriesAccessor,
  valueAccessor,
  filter,
  ...rest
}) {
  const { data, isLoading } = usePipelineDataContextWithVariables(pipeline, variables)

  /** Refine the list of activities to show */
  const activities = useMemo(() => {
    const series = get(data, seriesAccessor) || []
    return series.map((item) => (!valueAccessor || valueAccessor === '$') ? item : get(item, valueAccessor))
      .filter(x => evaluateObjectFilter(x, filter))
  }, [data, seriesAccessor, valueAccessor, filter])

  if (isLoading) {
    return null
  }

  return (
    <ActivityList
      {...rest}
      activities={activities}
    />
  )
}

DDPActivityList.propTypes = {
  /** The data pipeline to execute */
  pipeline: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),

  /** Default values for variables */
  variables: PropTypes.object,

  /** Finds the array in the pipeline response */
  seriesAccessor: PropTypes.string,

  /** Finds the item value in the pipeline response */
  valueAccessor: PropTypes.string,

  /** Filter items (in objectFilter format) */
  filter: PropTypes.object,

  className: PropTypes.string,
  style: PropTypes.object,

  itemClassName: PropTypes.string,
  itemStyle: PropTypes.object,

  component: PropTypes.node,
  componentProps: PropTypes.object
}

DDPActivityList.defaultProps = {
  seriesAccessor: 'activities',
  valueAccessor: ''
}

export default DDPActivityList
